import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConnectorStatus } from "../../_objects/connector";
import { HttpService } from "../http.service";

@Injectable({
  providedIn: "root"
})
export class ConnectorOnlineService extends HttpService {
  constructor(private http: HttpClient) {
    super();
    super.setHttpClient(http);
  }

  toggleConnector(connectorStatus: ConnectorStatus): Observable<void> {
    const endpoint = super.getEndpoint("connectors");
    return this.http.post<void>(endpoint, connectorStatus);
  }

  getConnectorStatus(connectorId: string): Observable<ConnectorStatus> {
    const endpoint = super.getEndpoint(`connectors/${connectorId}`);
    return this.http.get<ConnectorStatus>(endpoint);
  }
}
